module.exports = __webpack_public_path__ + "img/circle_success.df540b8c.svg";